import LanguageMenu from "component/menu/Language";
import GamesLayout from "component/menu/GamesLayout";
import FloatingGamesLayout from "component/menu/FloatingGamesLayout";
import Dropdown from "component/menu/Dropdown";
import SearchBar from "component/menu/SearchBar";

export { LanguageMenu, GamesLayout, Dropdown, FloatingGamesLayout, SearchBar };

export default Object.assign({
  LanguageMenu,
  GamesLayout,
  Dropdown,
  FloatingGamesLayout,
  SearchBar,
});
